





































































































































































































































































import Component from 'vue-class-component';
import Vue from 'vue';
import BaseAttributeCollection from '../../classes/attributes/baseAttributeCollection';
import DiceAttributeInput from './diceAttributeInput.vue';
import TalentCollection from '../../classes/attributes/talentCollection';
import Character, { CharacterExportData } from '@/classes/character/character';
import { TalentField } from '../../classes/character/allValues';
import { Prop, Watch } from 'vue-property-decorator';
import { CharacterClasses } from '@/classes/character/classes';

@Component({
  components: { DiceAttributeInput },
})
export default class CreateCharacter extends Vue {
  @Prop()
  public open!: boolean;

  public characterId!: string;

  private stepModel = 1;

  private character = new Character();

  private attributeCollection = new BaseAttributeCollection();
  private talentCollection = new TalentCollection();

  private stepsValid: boolean[] = [false, false];

  private requiredRule = [(v) => !!v || 'Dieses Feld ist verpflichtend'];

  private addTalentModel = {};

  private talentModels = {};

  private attributeModels = {};

  private resourceModels = { lep: 0, aip: 0, ini: 0, ep: 0 };

  private diceModels = {};

  // Base values
  private nameModel = '';
  private classModel = '';
  private raceModel = '';

  private characterSaving = false;

  private loading = false;

  get allClasses() {
    return CharacterClasses.allClasses;
  }

  get attributes() {
    return this.attributeCollection.baseDiceAttributes;
  }

  get elements() {
    return this.attributeCollection.baseElements.filter((element) => !element.isProtection);
  }

  get protectionElements() {
    return this.attributeCollection.baseElements.filter((element) => element.isProtection);
  }

  get talentfields() {
    return this.talentCollection.getAllTalentFields();
  }

  @Watch('characterId')
  private onCharacterIdChange(characterId) {
    if (!characterId) {
      return;
    }

    this.loading = true;
    this.$store.dispatch('loadCharacter', this.characterId).then((characterData: CharacterExportData) => {
      this.character = new Character(characterData);
    });
  }

  private diceAttributeChange(abbreviation: string, type: string, value: number) {
    if (typeof this.attributeModels[abbreviation] === 'undefined') {
      this.attributeModels[abbreviation] = { dice: 0, modifier: 0 };
    }
    this.attributeModels[abbreviation][type] = value;
  }

  private finalizeAndSaveCharacter() {
    this.character.name = this.nameModel;
    this.character.class = this.classModel;
    this.character.race = this.raceModel;

    Object.keys(this.resourceModels).forEach((resourceAbbreviation) => {
      this.character.addNumberModifier(
        resourceAbbreviation,
        'value',
        this.resourceModels[resourceAbbreviation],
        'start',
      );
    });

    Object.keys(this.attributeModels).forEach((attributeAbbreviation) => {
      this.character.addDiceModifier(
        attributeAbbreviation,
        this.attributeModels[attributeAbbreviation].dice,
        this.attributeModels[attributeAbbreviation].modifier,
        'start',
      );
    });

    Object.keys(this.talentModels).forEach((talentId) => {
      this.character.addNumberModifier(talentId, 'value', this.talentModels[talentId], 'start');
    });

    const characterData = this.character.export();
    this.characterSaving = true;
    this.$store.dispatch('saveCharacter', characterData).then(() => {
      this.characterSaving = false;
      this.$emit('characterCreated');
    });
  }

  /**
   * Adds a new talent to the character
   */
  private addTalentToCharacter(talentfieldId: string) {
    if (typeof this.addTalentModel[talentfieldId] !== 'string') {
      throw new Error('No talent stored in model for field ' + talentfieldId);
    }
    const talent = this.talentCollection.getTalentByAbbreviation(this.addTalentModel[talentfieldId]);
    this.character.addAttribute(talent);
    delete this.addTalentModel[talentfieldId];
  }

  /**
   * Removes the given talent from the character
   */
  private removeTalentFromCharacter(talentfieldId: string, talentAbbreviation: string) {
    this.character.removeAttributeByAbbreviation(talentAbbreviation);
    this.talentModels[talentAbbreviation] = 0;
  }

  /**
   * Returns all talents of a field minus the ones in the character
   */
  private getAvailableTalentsByTalentField(talentField: TalentField) {
    const allTalentsOfField = this.talentCollection.getTalentsByTalentField(talentField);
    return allTalentsOfField
      .filter(
        (talent) =>
          this.getTalentsOfCharacterByField(talentField).findIndex(
            (characterTalent) => talent.abbreviation === characterTalent.abbreviation,
          ) === -1,
      )
      .map((talent) => {
        return { text: talent.name, value: talent.abbreviation };
      });
  }
  /**
   * Helper function to return the talents of the character sorted by name
   */
  private getTalentsOfCharacterByField(talentField: string) {
    return this.character.getTalentsByTalentField(talentField);
  }
}
